// extracted by mini-css-extract-plugin
export default {"add":"styles_add__7av4K"};